export const environment = {
    siteId: 2,
    name: 'wheelssport',
    apiBaseUrl: 'https://wheelssport-api-staging.clicktotravel.es/api',
    baseUrl: 'https://wheelssport-api-staging.clicktotravel.es',
    token: '',
    email: 'front@clicktotravel.es',
    password: 'TZht@ou.eA2vz4qrQ@7B',
    userPanel: 'admin',
    passPanel: '1234',
    booking_engine_enabled: false, // General switch for booking engine
    booking_engine_top_enabled: false, // Switch for booking engine button in top sliders
    booking_engine_extern: true,
    booking_button_engine_enabled: true, // Button booking engine
    openInNewWindow: false,
    trailingSlash: false,
    multipleMotorsModal: false,
    normalizeUrlsToLowercase: false,
    minSizeMobileHeader: 768,
    menuComplexLinks: false,
    booking_engine_widget: false, // Use widget booking engine
    booking_engine_widget_dynamic: false, // widget static down
    dataBase: '/data/',
    sitesIndexFile: 'sites.json',
    fallbackUrl: 'https://staging-wheelssport.clicktotravel.es/',
};
